import A11yDialog from 'a11y-dialog';

export function modal(el) {
  function init() {
    new A11yDialog(el);
  }

  return { init };
}
